export class CrossSourceEntryModel {
    constructor(
        public entryId: number,
        public entryNumber: number,
        public gid: number,
        public designation: string,
        public cross: string,
        public groupGid: number,
        public sourceList: string
    ) {
    }
}
